export const calculatePasswordStrength = (password: string) => {
  let strength = 0;
  if (/[a-z]/.test(password)) strength++; // lowercase letter
  if (/[A-Z]/.test(password)) strength++; // uppercase letter
  if (/[0-9]/.test(password)) strength++; // digit
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength++; // symbol
  return strength;
};

// Get password strength color based on overall complexity
export const getPasswordStrengthColor = (strengthLevel: number) => {
  if (strengthLevel >= 4) return '#19be60'; // Green - strong (all 4 criteria)
  if (strengthLevel >= 3) return '#006fee'; // Blue - good (3 criteria)
  if (strengthLevel >= 2) return '#e8a323'; // Orange - medium (2 criteria)
  if (strengthLevel >= 1) return '#f31260'; // Red - weak (1 criteria)
  return '#d4d4d8'; // Gray - none
};
